import { URITypeMap } from '../../../enums/uri_type';
import { URIParticle } from '../../../enums/uri_particle';
import { encodeComponent, encodeComponents, encodeQueryString, } from '../../helpers';
import { createSerializerDefinition } from '../helpers';
const [declareURISerializer, URISerializers] = createSerializerDefinition();
declareURISerializer(URITypeMap.ALBUM, (uri) => {
    const components = [URITypeMap.ALBUM, uri.id];
    if (uri.disc) {
        components.push(uri.disc);
    }
    return components;
});
declareURISerializer(URITypeMap.AD, (uri) => {
    return [URITypeMap.AD, uri.id];
});
declareURISerializer(URITypeMap.ARTIST, (uri) => {
    return [URITypeMap.ARTIST, uri.id];
});
declareURISerializer(URITypeMap.QUEUE, () => {
    return [URITypeMap.QUEUE];
});
declareURISerializer(URITypeMap.GENRE, (uri) => {
    return [URITypeMap.GENRE, uri.genre];
});
declareURISerializer(URITypeMap.ARTIST_TOPLIST, (uri) => {
    return [URITypeMap.ARTIST, uri.id, URIParticle.TOP, uri.toplist];
});
declareURISerializer(URITypeMap.ARTIST_CONCERTS, (uri) => {
    return [URITypeMap.ARTIST, uri.id, URIParticle.CONCERTS];
});
declareURISerializer(URITypeMap.DAILY_MIX, (uri) => {
    return [URITypeMap.DAILY_MIX, uri.id];
});
declareURISerializer(URITypeMap.SEARCH, (uri, format) => {
    return [URITypeMap.SEARCH, encodeComponent(uri.query, format)];
});
declareURISerializer(URITypeMap.TRACK, (uri) => {
    let base62 = uri.id;
    if (uri.context || uri.play) {
        base62 += encodeQueryString({
            context: uri.context,
            play: uri.play,
        });
    }
    if (uri.anchor) {
        base62 += `#${uri.anchor}`;
    }
    return [URITypeMap.TRACK, base62];
});
declareURISerializer(URITypeMap.TRACKSET, (uri) => {
    let trackIds = [];
    if (uri.tracks) {
        for (let i = 0, len = uri.tracks.length; i < len; i++) {
            trackIds.push(uri.tracks[i].id);
        }
    }
    trackIds = [trackIds.join(',')];
    // Index can be 0 sometimes (required for trackset)
    if (uri.index !== null && typeof uri.index !== 'undefined') {
        trackIds.push('#', uri.index.toString());
    }
    return [URITypeMap.TRACKSET, encodeComponent(uri.name)].concat(trackIds);
});
declareURISerializer(URITypeMap.FACEBOOK, (uri) => {
    return [URIParticle.USER, URITypeMap.FACEBOOK, uri.uid];
});
declareURISerializer(URITypeMap.AUDIO_FILE, (uri) => {
    return [URITypeMap.AUDIO_FILE, uri.extension, uri.id];
});
declareURISerializer(URITypeMap.FOLDER, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.FOLDER,
        uri.id,
    ];
});
declareURISerializer(URITypeMap.FOLLOWERS, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.FOLLOWERS,
    ];
});
declareURISerializer(URITypeMap.FOLLOWING, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.FOLLOWING,
    ];
});
declareURISerializer(URITypeMap.PLAYLIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.PLAYLIST,
        uri.id,
    ];
});
declareURISerializer(URITypeMap.PLAYLIST_V2, (uri) => {
    return [URITypeMap.PLAYLIST, uri.id];
});
declareURISerializer(URITypeMap.STARRED, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.STARRED,
    ];
});
declareURISerializer(URITypeMap.TEMP_PLAYLIST, (uri) => {
    return [URITypeMap.TEMP_PLAYLIST, uri.origin, uri.data];
});
declareURISerializer(URITypeMap.CONTEXT_GROUP, (uri) => {
    return [URITypeMap.CONTEXT_GROUP, uri.origin, uri.name];
});
declareURISerializer(URITypeMap.USER_TOPLIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URIParticle.TOP,
        uri.toplist,
    ];
    // Legacy Toplist
});
declareURISerializer(URITypeMap.USER_TOP_TRACKS, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.TOPLIST,
    ];
});
declareURISerializer(URITypeMap.TOPLIST, (uri) => {
    return [URIParticle.TOP, uri.toplist].concat(uri.global || !uri.country ? [URIParticle.GLOBAL] : ['country', uri.country]);
});
declareURISerializer(URITypeMap.INBOX, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.INBOX,
    ];
});
declareURISerializer(URITypeMap.ROOTLIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.ROOTLIST,
    ];
});
declareURISerializer(URITypeMap.PUBLISHED_ROOTLIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.PUBLISHED_ROOTLIST,
    ];
});
declareURISerializer(URITypeMap.COLLECTION_TRACK_LIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.COLLECTION_TRACK_LIST,
        uri.id,
    ];
});
declareURISerializer(URITypeMap.PROFILE, (uri, format) => {
    if (uri.args && uri.args.length > 0) {
        return [URIParticle.USER, encodeComponent(uri.username, format)].concat(uri.args);
    }
    return [URIParticle.USER, encodeComponent(uri.username, format)];
});
declareURISerializer(URITypeMap.LOCAL_ARTIST, (uri, format) => {
    return [URITypeMap.LOCAL_TRACK, encodeComponent(uri.artist, format)];
});
declareURISerializer(URITypeMap.LOCAL_ALBUM, (uri, format) => {
    return [
        URITypeMap.LOCAL_TRACK,
        encodeComponent(uri.artist, format),
        encodeComponent(uri.album, format),
    ];
});
declareURISerializer(URITypeMap.LOCAL_TRACK, (uri, format) => {
    return [
        URITypeMap.LOCAL_TRACK,
        encodeComponent(uri.artist, format),
        encodeComponent(uri.album, format),
        encodeComponent(uri.track, format),
        uri.duration,
    ];
});
declareURISerializer(URITypeMap.LIBRARY, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.LIBRARY,
    ].concat(uri.category ? [uri.category] : []);
});
declareURISerializer(URITypeMap.IMAGE, (uri) => {
    return [URITypeMap.IMAGE, uri.id];
});
declareURISerializer(URITypeMap.MOSAIC, (uri) => {
    let components = [];
    if (uri.ids) {
        components = uri.ids.slice(0);
    }
    components.unshift(URITypeMap.MOSAIC);
    return components;
});
declareURISerializer(URITypeMap.RADIO, (uri, format) => {
    return encodeComponents(uri.args, format, [URITypeMap.RADIO]);
});
declareURISerializer(URITypeMap.SPECIAL, (uri, format) => {
    return encodeComponents(uri.args, format, [URITypeMap.SPECIAL]);
});
declareURISerializer(URITypeMap.STATION, (uri, format) => {
    return encodeComponents(uri.args, format, [URITypeMap.STATION]);
});
declareURISerializer(URITypeMap.APPLICATION, (uri, format) => {
    return encodeComponents(uri.args, format, [URIParticle.APP, uri.id]);
});
declareURISerializer(URITypeMap.COLLECTION_ALBUM, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.COLLECTION,
        URITypeMap.ALBUM,
        uri.id,
    ];
});
declareURISerializer(URITypeMap.COLLECTION_MISSING_ALBUM, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.COLLECTION,
        URITypeMap.ALBUM,
        uri.id,
        'missing',
    ];
});
declareURISerializer(URITypeMap.COLLECTION_ARTIST, (uri, format) => {
    return [
        URIParticle.USER,
        encodeComponent(uri.username, format),
        URITypeMap.COLLECTION,
        URITypeMap.ARTIST,
        uri.id,
    ];
});
declareURISerializer(URITypeMap.COLLECTION, (uri, format) => {
    const components = [URITypeMap.COLLECTION].concat(uri.category ? [uri.category] : []);
    if (uri.username) {
        return [URIParticle.USER, encodeComponent(uri.username, format)].concat(components);
    }
    return components;
});
declareURISerializer(URITypeMap.COMMENT, (uri) => {
    return [URITypeMap.COMMENT, uri.id];
});
declareURISerializer(URITypeMap.EPISODE, (uri) => {
    let base62 = uri.id;
    if (uri.context || uri.play) {
        base62 += encodeQueryString({
            context: uri.context,
            play: uri.play,
        });
    }
    return [URITypeMap.EPISODE, base62];
});
declareURISerializer(URITypeMap.SHOW, (uri) => {
    return [URITypeMap.SHOW, uri.id];
});
declareURISerializer(URITypeMap.LIVE, (uri) => {
    return [URITypeMap.LIVE, uri.id];
});
declareURISerializer(URITypeMap.ROOM, (uri) => {
    return [URITypeMap.ROOM, uri.id];
});
declareURISerializer(URITypeMap.EXPRESSION, (uri) => {
    return [URITypeMap.EXPRESSION, uri.id];
});
declareURISerializer(URITypeMap.CONCEPT, (uri) => {
    return [URITypeMap.CONCEPT, uri.id];
});
declareURISerializer(URITypeMap.CONCERT, (uri) => {
    return [URITypeMap.CONCERT, uri.id];
});
declareURISerializer(URITypeMap.SOCIAL_SESSION, (uri) => {
    return [URITypeMap.SOCIAL_SESSION, uri.id];
});
declareURISerializer(URITypeMap.JAM, (uri) => {
    const parts = [URITypeMap.JAM];
    if (uri.contextType && uri.id) {
        parts.push(uri.contextType, uri.id);
    }
    if (uri.play) {
        parts.push('play');
    }
    return parts;
});
declareURISerializer(URITypeMap.INTERRUPTION, (uri) => {
    return [URITypeMap.INTERRUPTION, uri.id];
});
declareURISerializer(URITypeMap.MERCH, (uri) => {
    return [URITypeMap.MERCH, uri.id];
});
declareURISerializer(URITypeMap.MERCHHUB, () => {
    return [URITypeMap.MERCHHUB];
});
declareURISerializer(URITypeMap.PRERELEASE, (uri) => {
    return [URITypeMap.PRERELEASE, uri.id];
});
declareURISerializer(URITypeMap.UNKNOWN, (uri, format) => {
    return encodeComponents(uri.args, format);
});
declareURISerializer(URITypeMap.MEDIA, (uri) => {
    return [URITypeMap.MEDIA, uri.id];
});
declareURISerializer(URITypeMap.POLL, (uri) => {
    return [URITypeMap.POLL, uri.id];
});
declareURISerializer(URITypeMap.QUESTION, (uri) => {
    return [URITypeMap.QUESTION, uri.id];
});
declareURISerializer(URITypeMap.RESPONSE, (uri) => {
    return [URITypeMap.RESPONSE, uri.id];
});
declareURISerializer(URITypeMap.FESTIVAL, (uri) => {
    return [URITypeMap.FESTIVAL, uri.id];
});
declareURISerializer(URITypeMap.TOUR, (uri) => {
    return [URITypeMap.TOUR, uri.id];
});
declareURISerializer(URITypeMap.CONTRIBUTOR, (uri) => {
    return [URITypeMap.CONTRIBUTOR, uri.id];
});
declareURISerializer(URITypeMap.CULTURAL_MOMENT, (uri) => {
    return [URITypeMap.CULTURAL_MOMENT, URIParticle.HUB, uri.id];
});
declareURISerializer(URITypeMap.VENUE, (uri) => {
    return [URITypeMap.VENUE, uri.id];
});
declareURISerializer(URITypeMap.VIDEO, (uri) => {
    return [URITypeMap.VIDEO, uri.id];
});
declareURISerializer(URITypeMap.CACHED_FILES, () => {
    return [URITypeMap.CACHED_FILES];
});
declareURISerializer(URITypeMap.CANVAS, (uri) => {
    return [URITypeMap.CANVAS, uri.id];
});
declareURISerializer(URITypeMap.CHAT_MESSAGE, (uri) => {
    return [URITypeMap.CHAT_MESSAGE, uri.id];
});
declareURISerializer(URITypeMap.COURSE, (uri) => {
    return [URITypeMap.COURSE, uri.id];
});
declareURISerializer(URITypeMap.LESSON, (uri) => {
    return [URITypeMap.LESSON, uri.id];
});
declareURISerializer(URITypeMap.PROMOTER, (uri) => {
    return [URITypeMap.PROMOTER, uri.id];
});
declareURISerializer(URITypeMap.PROMOTION, (uri) => {
    return [URITypeMap.PROMOTION, uri.id];
});
declareURISerializer(URITypeMap.SITE, (uri) => {
    return [URITypeMap.SITE, uri.id];
});
declareURISerializer(URITypeMap.PRESENTS, (uri) => {
    return [URITypeMap.PRESENTS, uri.id];
});
declareURISerializer(URITypeMap.S4A_THIRD_PARTY, (uri) => {
    return [URITypeMap.S4A_THIRD_PARTY, uri.id];
});
declareURISerializer(URITypeMap.SUPPLEMENTARY_MATERIAL, (uri) => {
    return [URITypeMap.SUPPLEMENTARY_MATERIAL, uri.id];
});
declareURISerializer(URITypeMap.AUDIO, (uri) => {
    return [URITypeMap.AUDIO, uri.id];
});
export { URISerializers };
//# sourceMappingURL=index.js.map